export default __webpack_public_path__ + "static/whatplay-78dd9a38a188e622c0791198d1493b9e.png";